import { render } from "./InputBox.vue?vue&type=template&id=f33993a0&scoped=true&ts=true"
import script from "./InputBox.vue?vue&type=script&lang=ts"
export * from "./InputBox.vue?vue&type=script&lang=ts"

import "./InputBox.vue?vue&type=style&index=0&id=f33993a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f33993a0"]])

export default __exports__